import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { Precedenza } from '../shared/models/precedenza.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaPrecedenzeService extends AnagraficaBaseService<Precedenza> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaPrecedenze`);
  }

  get idProperty(): string {
    return 'precedenzaId';
  }

  get nameProperty(): string {
    return 'nomePrecedenza';
  }
}
